import { render, staticRenderFns } from "./PlacementsStartComponentPerformanceAdmin.vue?vue&type=template&id=269abce9&scoped=true&"
import script from "./PlacementsStartComponentPerformanceAdmin.vue?vue&type=script&lang=js&"
export * from "./PlacementsStartComponentPerformanceAdmin.vue?vue&type=script&lang=js&"
import style0 from "./PlacementsStartComponentPerformanceAdmin.vue?vue&type=style&index=0&id=269abce9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "269abce9",
  null
  
)

export default component.exports